var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 14.1004V16.6004C17.3341 16.8325 17.2866 17.0622 17.1936 17.2749C17.1006 17.4875 16.9643 17.6784 16.7933 17.8353C16.6222 17.9922 16.4203 18.1116 16.2005 18.186C15.9806 18.2603 15.7477 18.288 15.5165 18.2671C12.9522 17.9884 10.489 17.1122 8.32486 15.7087C6.31139 14.4293 4.60431 12.7222 3.32486 10.7087C1.91651 8.53474 1.04007 6.05957 0.76653 3.48374C0.745705 3.2533 0.773092 3.02104 0.846947 2.80176C0.920801 2.58248 1.03951 2.38098 1.1955 2.21009C1.3515 2.0392 1.54137 1.90266 1.75302 1.80917C1.96468 1.71569 2.19348 1.66729 2.42486 1.66707H4.92486C5.32928 1.66309 5.72136 1.80631 6.028 2.07002C6.33464 2.33373 6.53493 2.69995 6.59153 3.10041C6.69705 3.90046 6.89274 4.68601 7.17486 5.44207C7.28698 5.74034 7.31125 6.0645 7.24478 6.37614C7.17832 6.68778 7.02392 6.97383 6.79986 7.20041L5.74153 8.25874C6.92783 10.345 8.65524 12.0724 10.7415 13.2587L11.7999 12.2004C12.0264 11.9764 12.3125 11.8219 12.6241 11.7555C12.9358 11.689 13.2599 11.7133 13.5582 11.8254C14.3143 12.1075 15.0998 12.3032 15.8999 12.4087C16.3047 12.4658 16.6744 12.6697 16.9386 12.9817C17.2029 13.2936 17.3433 13.6917 17.3332 14.1004Z",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d7848e375b4c1a709de67bb5e0314f99.svg";
export { ForwardRef as ReactComponent };